

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Grid } from '@mui/material';
import moment from "moment-jalaali";
import { useEffect, useState } from 'react';
import { blue } from '@mui/material/colors';

export default function DialogUserInfo({userClient, ReqUser}) {

    const [dateReqCreate, setDateReqCreate] = useState()
    useEffect(() =>{
        if(ReqUser?.time){
            setDateReqCreate(moment(ReqUser?.time, 'YYYY-M-D HH:mm').format('jYYYY/jM/jD HH:mm'))
        }
        
    }, [])

  return (
    <div>
        <Accordion sx={{backgroundColor: blue[900], margin: 1}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{color: blue[100]}}/>}
                aria-controls="panel1a-content"
                id="panel1a-header"
                >
                <Typography
                    fontFamily='b_mitra' 
                    component="div"
                    variant="h6"
                    color={"pink.text"}
                    >
                    مشخصات کاربر {userClient?.profile?.bio &&
                    "(مشخصات: " + userClient?.profile?.bio + ")"} {userClient?.profile?.phone_user &&
                        "(تلفن: " + userClient?.profile?.phone_user + ")"} 
                </Typography>

            </AccordionSummary>
            <AccordionDetails >
                <div style={{backgroundColor: 'white', padding:10}}>
                    <Grid container spacing={1} alignItems='flex-end' >
                        <Grid item xs={6} >
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                color={blue[900]}
                                >
                                نام و نام خانوادگی : <b>{userClient?.profile?.bio}</b>
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <div>
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={blue[900]}
                                    >
                                    ایمیل : <b>{userClient?.email}</b>
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div>
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={blue[900]}
                                    >
                                    نام کاربری : <b>{userClient?.username}</b>
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div>
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={blue[900]}
                                    >
                                    شماره تماس : <b>{userClient?.profile?.phone_user}</b>
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div>
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={blue[900]}
                                    >
                                    زبان : <b>{userClient?.profile?.languge_user}</b>
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div>
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={blue[900]}
                                    >
                                    آدرس : <b>{userClient?.profile?.address_user}</b>
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </AccordionDetails>
        </Accordion>
        <Accordion sx={{backgroundColor: blue[900], margin:1}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{color: blue[100]}}/>}
                aria-controls="panel2a-content"
                id="panel2a-header"
                >
                <Typography
                    fontFamily='b_mitra' 
                    component="div"
                    variant="h6"
                    color={"pink.text"}
                    >
                    درخواست کاربر ({ReqUser?.job_detail &&
                    "موضوع: " + ReqUser?.job_detail})
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div style={{backgroundColor: 'white', padding: 10}}>
                    <Grid container spacing={1} alignItems='flex-end'>
                        <Grid item xs={6}>
                            <div>
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={blue[900]}
                                    >
                                    موضوع: <b>{ReqUser?.job_detail}</b>
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div>
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={blue[900]}
                                    >
                                    تاریخ ثبت: {dateReqCreate}
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div>
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={blue[900]}
                                    >
                                    توضیحات: <b>{ReqUser?.remarks}</b>
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </AccordionDetails>
        </Accordion>
    </div>
  )
}